import { createEvent, restore, sample } from 'effector'
import {
  PromoCodeUsageResponse,
  PromoCodeUsageRequest,
  PromoCodeUsage,
} from './types'
import { fx } from '../../../../libs'
import {
  changedDateFormat,
  isAllElementsOfSearchTextNotExist,
} from '../../../../libs/utils'

const DATE_FIELDS = ['activatedAt', 'depositedAt']

const mapSearchEntry = (key: string, value: any): [string, any] => {
  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => (date ? changedDateFormat(date?.$d) : `${date}`))
      : value
    return [key, dates]
  }

  return [key, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) =>
      mapSearchEntry(key, value),
    ),
  )
}

export const promoCodeUsageListMounted = createEvent<PromoCodeUsageRequest>()

export const getPromoCodeUsageList = fx<
  PromoCodeUsageRequest,
  PromoCodeUsageResponse
>({
  method: 'GET',
  url: `/deposit_bonus/promo_code_usages`,
})

export const $promoCodeUsageList = restore<PromoCodeUsage[]>(
  getPromoCodeUsageList.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfPromoCodeUsageList = restore(
  getPromoCodeUsageList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: promoCodeUsageListMounted,
  fn: ({ searchText, limit, page, orderBy, orderDirection }) => {
    let newObj = {}

    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    // @ts-ignore
    query['where'] = `${JSON.stringify(newObj)}`

    return {
      query,
    }
  },
  target: getPromoCodeUsageList,
})
